import { UcoastEl } from '@/scripts/core/UcoastEl'

/**
 * <anchor-tile> — the pinned "anchor image" in sections/hp-products-anchor.liquid.
 * Adds a session-level dismiss: clicking the X hides the anchor for the rest of the browser
 * session (sessionStorage, keyed per section). Suppressed in the theme editor so merchants can
 * still see and configure the anchor while editing.
 */
export class AnchorTile extends UcoastEl {
	static htmlSelector = 'anchor-tile'
	private initialized = false

	override connectedCallback() {
		super.connectedCallback()
		if (this.initialized) return
		this.initialized = true

		const sectionId = this.getAttribute('data-section-id') ?? ''
		const storageKey = `hp-anchor-dismissed:${sectionId}`
		const tile = this.closest('.hp-products__anchor') as HTMLElement | null
		const inEditor =
			(window as Window & { Shopify?: { designMode?: boolean } }).Shopify?.designMode === true

		const dismiss = (persist: boolean) => {
			if (tile) tile.classList.add('is-dismissed')
			if (persist) {
				try {
					window.sessionStorage.setItem(storageKey, '1')
				} catch {
					/* sessionStorage unavailable (private mode) — dismiss for this render only */
				}
			}
		}

		let alreadyDismissed = false
		try {
			alreadyDismissed = window.sessionStorage.getItem(storageKey) === '1'
		} catch {
			/* no-op */
		}
		if (!inEditor && alreadyDismissed) dismiss(false)

		const closeBtn = this.querySelector('[data-uc-anchor-close]')
		closeBtn?.addEventListener('click', (event) => {
			event.preventDefault()
			dismiss(true)
		})
	}
}
